// highlight term in string
import React from "react";

export type HighLightProps = {
  text: string;
  term: string;
  className?: string;
};

export const Highlight: React.FC<HighLightProps> = ({ text, term, className }) => {
  if (!term || !text) return <div className={className}>{text}</div>;

  const highlightRegex = new RegExp(`(${term})`, "gi");
  const parts = text.split(highlightRegex);

  return (
    <div className={className}>
      {parts.map((part, index) => {
        const isHighlight = highlightRegex.test(part);
        return isHighlight ? (
          <span key={index} className="text-textHighlight">
            {part}
          </span>
        ) : (
          part
        );
      })}
    </div>
  );
};
